import React, { Dispatch, SetStateAction } from "react";
import { Grid } from "@mui/material";
// @ts-ignore
import { StriimTypography, StriimListItem, StriimRadioGroup, StriimControlLabel, StriimRadio } from "@striim/striim-ui";

import { styles } from "./schemas-list.styles";
import { Schema } from "../../schema-table";

interface SchemasListSingleSelectionProps {
    schemas: Schema[];
    currentSelection: Schema;
    selectedSchema: Schema;
    setSelectedSchema: Dispatch<SetStateAction<Schema>>;
}

const SchemasListSingleSelection: React.FC<SchemasListSingleSelectionProps> = ({
    schemas,
    currentSelection,
    selectedSchema,
    setSelectedSchema
}) => {
    return (
        <StriimRadioGroup row={false} value={selectedSchema.name} onChange={() => {}}>
            {schemas.map(schema => {
                const isSchemaSelected = schema.name === currentSelection?.name;
                const tablesCount = schema.tables?.length || 0;
                const selectedTablesCount = schema.tables?.filter(table => !!table.isSelected)?.length || 0;
                return (
                    <StriimListItem
                        key={schema.name}
                        selected={schema.name === currentSelection?.name}
                        divider={false}
                        sx={[isSchemaSelected ? styles.schemaSelected : "", styles.radioListItem]}
                        onClick={() => setSelectedSchema(schema)}
                    >
                        <Grid
                            container
                            flexDirection="column"
                            p={0.2}
                            pl={1.2}
                            sx={(styles.schemaListItem, styles.schemaListItemSelected)}
                        >
                            <Grid container alignItems={"center"} gap={1}>
                                <StriimControlLabel
                                    key={schema.name}
                                    value={schema.name}
                                    control={<StriimRadio />}
                                    label={
                                        <StriimTypography
                                            variant="body4"
                                            sx={[
                                                styles.schemaItem,
                                                isSchemaSelected ? styles.schemaListItemSelected : styles.schemaListItem
                                            ]}
                                        >
                                            {schema.name}
                                        </StriimTypography>
                                    }
                                    style={styles.label}
                                />
                            </Grid>
                            <Grid container pl={4}>
                                <StriimTypography
                                    variant="caption3"
                                    sx={isSchemaSelected ? styles.schemaListItemSelected : styles.schemaListItem}
                                >
                                    {selectedTablesCount}/{tablesCount} selected
                                </StriimTypography>
                            </Grid>
                        </Grid>
                    </StriimListItem>
                );
            })}
        </StriimRadioGroup>
    );
};

export default SchemasListSingleSelection;
